import type { PayeurType } from '@/types';

/**
 * Relais entre l'encaissement au comptant et la fiche payeur en création.
 *
 * Flux : depuis l'encaissement au comptant on « arme » un retour avant d'ouvrir la
 * fiche payeur en création ; à l'enregistrement, la fiche mémorise le payeur créé et
 * renvoie sur l'encaissement, qui le consomme pour le pré-sélectionner.
 *
 * On s'appuie sur `sessionStorage` (comme le flux embedded/LOOC de l'app) car la
 * navigation passe par les `Menu` de `@mairistem/module` (le state du router ne
 * survit pas de façon fiable).
 */
const RETOUR_KEY = 'comptant.payeur.retour';
const PAYEUR_KEY = 'comptant.payeur.cree';

export const armerRetourComptant = (): void => {
  sessionStorage.setItem(RETOUR_KEY, '1');
};

export const annulerRetourComptant = (): void => {
  sessionStorage.removeItem(RETOUR_KEY);
};

export const doitRetournerAuComptant = (): boolean => sessionStorage.getItem(RETOUR_KEY) === '1';

/** Mémorise le payeur créé et lève le drapeau de retour. */
export const memoriserPayeurCree = (payeur: PayeurType): void => {
  sessionStorage.removeItem(RETOUR_KEY);
  sessionStorage.setItem(PAYEUR_KEY, JSON.stringify(payeur));
};

/** Renvoie le payeur créé en attente (et le retire du stockage). */
export const consommerPayeurCree = (): PayeurType | null => {
  const brut = sessionStorage.getItem(PAYEUR_KEY);
  sessionStorage.removeItem(PAYEUR_KEY);

  if (!brut) return null;

  try {
    return JSON.parse(brut) as PayeurType;
  } catch {
    return null;
  }
};
